import React, { useState, useEffect } from "react";
import { getSalas } from "../../services/salas";
import CardSala from "../CardSala";
import "./styles.css";

const CardSalas = ({ onClickSchedule, selectedDate }) => {
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    const fetchSalas = async () => {
      try {
        const salas = await getSalas();
        const roomsWithTypes = salas.map((room) => ({
          ...room,
          type: room.nome.toLowerCase().includes("auditório") ? "auditório" : "sala de atendimento",
        }));
        setRooms(roomsWithTypes);
      } catch (error) {
        console.error("Erro ao buscar salas:", error);
      }
    };

    fetchSalas();
  }, []);

  return (
    <div className="rooms">
      {rooms.map((room) => (
        <CardSala
          key={room._id} // Use o _id como chave
          room={{
            id: room._id, // Mapeie _id para id
            name: room.nome, // Mapeie nome para name
            image: room.imagem, // Mapeie imagem para image
            type: room.type, // Mapeie tipo para type
            schedules: room.horarios, // Certifique-se de que os horários estão mapeados corretamente
          }}
          selectedDate={selectedDate} // Passa a data selecionada
          onClickSchedule={onClickSchedule} // Passa a função de clique
        />
      ))}
    </div>
  );
};

export default CardSalas;
